<template>
	<div class="hero-banner">
		<screen-fill class="hero-banner">
			<banner class="hero-banner__banner header--additive-padding" :backgrounds="backgrounds">
				<slot />
			</banner>
		</screen-fill>
	</div>
</template>

<script>
import ScreenFill from '../molecules/ScreenFill'
import Banner from '../molecules/Banner'

export default {
	name: 'HeroBanner',
	components: {
		Banner,
		ScreenFill
	},
	data () {
		return {
		}
	},
	props: {
		backgrounds: [String, Object],
	},
	computed: {
	},
	created: function()
	{
	},
	mounted: function()
	{
	},
	methods: {
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".hero-banner";
	#{$c}
	{
		.banner
		{
			height: 100%;

			&__content
			{
				@include media(not-phab)
				{
					max-width: 100%;
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/organisms/HeroBanner.vue